import { AppError } from 'types';
import { ErrorStore as ErrorStoreInterface } from 'interfaces';
import { makeAutoObservable } from 'mobx';

const defaultError: AppError = {};

class ErrorStore implements ErrorStoreInterface {
  constructor() {
    makeAutoObservable(this);
  }

  error: AppError = defaultError;

  setError = (error: AppError): void => {
    this.error = error;
  };

  clearError = (): void => {
    this.setError(defaultError);
  };

  get hasError() {
    return !!this.error.title || !!this.error.description;
  }
}

export default ErrorStore;
